import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTopbar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-topbar, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutTopbar"><path d="M3 9V3H21V9H3Z" fill="currentColor"/><path d="M3 10V21L11.5 21V10H3Z" fill="currentColor"/><path d="M12.5 21L21 21V10H12.5V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutTopbar;
